import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { AUTH_LOGOUT_DONE } from '../../util/auth';
import { PATH_WEB_HOME } from '../../config/server';
import CompWrapper from './func';

export class Logout extends Component {
  componentDidMount() {
    const { dispatch } = this.props;
    //        this.openNotificationWithIcon('warning')
    dispatch({
      type: AUTH_LOGOUT_DONE,
    });

    const { history } = this.props;
    history.push(PATH_WEB_HOME);
  }

  render() {
    return (
      <></>
    );
  }
}

Logout.propTypes = {
  auth: PropTypes.shape({
    status: PropTypes.string.isRequired,
  }).isRequired,
  ui: PropTypes.shape({
    cookieVisibility: PropTypes.bool.isRequired,
    uiForm: PropTypes.object.isRequired,
  }).isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
};

export default CompWrapper(Logout, 'page_logout');
